import React from 'react'
import popup from '~/views/Popup/popup'

const NoSubscriptionInfo = (props) => {
    const errorMessage = props.subscription && props.subscription.subscriptionInfo.errorMessage
    return (
      <section>
      	<div className="title site-color">Subscription</div>
        <div className="detail">
        	<div className="title site-color">Subscription</div>
        	<div className="main">
            <div className="key">{(errorMessage ? errorMessage : 'Not Started')}</div>
          </div>	
          <div className="buttons">
            <a href="/viewplans" className="button">Subscribe Now</a>
            { props.transaction && 
              <div 
                className="button" 
                onClick={ _ => popup.billingHistory() }>
                Billing History
              </div> }
          </div>
        </div>
        <div className="clearfix"></div>
      </section>)
}

export default NoSubscriptionInfo;
